import {
  HourOfDay,
  OrgInterface,
  SequenceConditions,
  SequenceInterface,
  SequenceRecordInterface,
  SequenceSubType,
  SequenceType,
  SequenceUserEventInterface,
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK apps/server/src/API/Sequences/Sequences.Controller.ts

export class SequencesAPI {
  static forceCheckSequence(orgId: number, sequenceId: number, hour: HourOfDay) {
    return APIService.Sync.post<boolean>(`/sequences/org/${orgId}/sequence/${sequenceId}/check?hour=${hour}&force=true`);
  }
  static async getOrgsWithSequencesEnabled() {
    return APIService.Sync.get<OrgInterface[]>("/sequences/orgs/enabled");
  }
  static async checkAllSequencesForOrg(orgId: number, hour: HourOfDay) {
    return APIService.Sync.post(`/sequences/org/${orgId}/check?hour=${hour}`);
  }
  static async getSequences(orgId: number) {
    return APIService.Sync.get<SequenceInterface[]>(`/sequences/org/${orgId}`);
  }
  static async getSequenceRecords(orgId: number, sequenceId: number) {
    return APIService.Sync.get<SequenceRecordInterface[]>(`/sequences/org/${orgId}/sequence/${sequenceId}/records`);
  }
  static async getSequenceUserEventsForRecord(orgId: number, sequenceId: number, recordId: number) {
    return APIService.Sync.get<SequenceUserEventInterface[]>(`/sequences/org/${orgId}/sequence/${sequenceId}/record/${recordId}/events`);
  }

  static async createSequence(orgId: number, name: string, type: SequenceType, subType: SequenceSubType, questSlug: string) {
    return APIService.Sync.post<SequenceInterface>(`/sequences/org/${orgId}`, { name, type, subType, questSlug });
  }

  static async updateSequence(orgId: number, sequenceId: number, sequence: Partial<SequenceInterface>) {
    return APIService.Sync.put<SequenceInterface>(`/sequences/org/${orgId}/sequence/${sequenceId}`, sequence);
  }
}
